export interface FilterPill {
  label: string;
  key: string;
}

/**
 * Minimal deal shape for listing rows and detail-view tabs.
 * DEAL_ID is string | number because the server (Genesis) defines it as LONG; we normalize with String() for keys/tab ids.
 */
export interface DetailViewDeal {
  DEAL_ID?: string | number;
  DEAL_STATUS?: string;
  DEAL_DESCRIPTION?: string;
  [key: string]: unknown;
}

export interface EnumValuePair {
  COLUMN_NAME: string;
  COLUMN_VALUE: string;
}

export const operandConversion = {
  equals: '=',
  lessThan: '<',
  greaterThan: '>',
  lessThanOrEqual: '<=',
  greaterThanOrEqual: '>=',
};

/**
 * Deal status values from API/backend. Single source of truth for deal status strings.
 * Use these instead of string literals when checking or displaying deal status.
 */
export enum DealStatusEnum {
  NONE = 'NONE',
  EXPECTED = 'Expected',
  DAY_TO_DAY = 'Day-to-Day',
  WEEK_OF = 'Week Of',
  ANNOUNCED = 'Announced',
  PRICE_IDEAS = 'Price Ideas',
  PRELIMINARY_PRICING = 'Preliminary Pricing',
  RETAIL_ORDER_PERIOD = 'Retail Order Period',
  VERBAL_AWARD_CXL_WINDOW = 'Verbal Award/CXL Window',
  AWAITING_ALLOTMENTS = 'Awaiting Allotments',
  ALLOTMENTS_AVAILABLE = 'Allotments Available',
  PRICED = 'Priced',
  SOLD = 'Sold',
  NOT_BOUGHT = 'Not Bought',
  CANCELLED = 'Cancelled',
}

export const LEGACY_NOT_PUBLISHED_STATUS = 'Not Published';

export enum TaxStatusEnum {
  TAXABLE = 'Taxable',
  TAX_EXEMPT = 'Tax-Exempt',
  TAX_EXEMPT_SPACED = 'Tax Exempt', // upstream variant
  VARIOUS = 'Various',
  AMT = 'AMT',
  Corp = 'Corp'
}

export const TasStatusLabel: Record<TaxStatusEnum, string> = {
  [TaxStatusEnum.TAX_EXEMPT]: 'T-E',
  [TaxStatusEnum.TAX_EXEMPT_SPACED]: 'T-E', // same label
  [TaxStatusEnum.TAXABLE]: 'TAX',
  [TaxStatusEnum.VARIOUS]: 'VAR',
  [TaxStatusEnum.AMT]: 'AMT',
  [TaxStatusEnum.Corp]: 'Corp'
};
